import { InjectionToken } from '@angular/core';

import { IEnvironment } from '../models/environment.interface';

/**
 * Provides the environment object
 */
export const ENVIRONMENT = new InjectionToken<IEnvironment>(
    '@sona/angular-shared-environment.environment'
);
